export const currentAdvancePayment = (state) => state.currentAdvancePayment
export const advances = (state) => state.advances
